import React, { createContext } from 'react';

export const RecoveryContext = createContext({
	contextPassword: '123',
	setContextPassword: () => {},
	contextEmail: 'a@m.ru',
	setContextEmail: () => {},
});
